<template>
  <td>
    <div v-if="!deleted" @click="destroy()" class="btn btn-danger">
      <i class="fas fa-trash"></i>
    </div>
    <div v-else>
      gelöscht
    </div>
  </td>
</template>

<script lang="babel">
export default {
  data() {
    return {
      deleted: false,
    }
  },
  props: ['model'],
  methods: {
    destroy() {
      this.$http.delete('/api/v1/friends/'+this.model.id).then(() => {
        this.deleted = true;
      });
    }
  }
};
</script>
